const envelope = {
  title: 'Sobre',
};

export default envelope;
